// Related Products and Posts Carousel for Mobile
document.addEventListener('DOMContentLoaded', function() {
  console.log('Related carousels script loaded');
  
  const relatedProductsSection = document.querySelector('.related-products');
  const relatedPostsSection = document.querySelector('.related-posts');
  
  let productsSwiperInstance = null;
  let postsSwiperInstance = null;

  // Check if we're on mobile (below 1024px)
  function isMobile() {
    return window.innerWidth < 1024;
  }

  // Initialize carousel for a specific container
  function initializeCarousel(container, swiperInstance, instanceName) {
    if (!container) return;
    
    console.log(`Initializing ${instanceName} carousel, isMobile:`, isMobile(), 'window width:', window.innerWidth);
    
    // Destroy existing instance if it exists
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    // Only initialize carousel on mobile
    if (isMobile()) {
      console.log(`Mobile detected, initializing ${instanceName} Swiper...`);
      try {
        // Different slidesPerView for products vs posts
        const isProducts = instanceName === 'Related Products';
        const baseSlidesPerView = isProducts ? 1.2 : 1;
        
        swiperInstance = new Swiper(container, {
          slidesPerView: baseSlidesPerView,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            480: {
              slidesPerView: isProducts ? 1.2 : 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: isProducts ? 1.2 : 1,
              spaceBetween: 30,
            },
          },
        });
        console.log(`${instanceName} carousel initialized successfully`);
        return swiperInstance;
      } catch (error) {
        console.error(`Error initializing ${instanceName} carousel:`, error);
      }
    } else {
      console.log(`Desktop detected, not initializing ${instanceName} carousel`);
    }
    return null;
  }

  // Initialize all carousels
  function initializeAllCarousels() {
    // Initialize products carousel
    if (relatedProductsSection) {
      const productsContainer = relatedProductsSection.querySelector('[data-swiper]');
      if (productsContainer) {
        productsSwiperInstance = initializeCarousel(productsContainer, productsSwiperInstance, 'Related Products');
      }
    }

    // Initialize posts carousel
    if (relatedPostsSection) {
      const postsContainer = relatedPostsSection.querySelector('[data-swiper]');
      if (postsContainer) {
        postsSwiperInstance = initializeCarousel(postsContainer, postsSwiperInstance, 'Related Posts');
      }
    }
  }

  // Initialize on load
  initializeAllCarousels();

  // Re-initialize on resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initializeAllCarousels();
    }, 250);
  });
});
